module.exports = xadminAuth;